import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bg-silver" }, [
  /*#__PURE__*/_createElementVNode("h2", null, " LIST PAYMENTOPTIONS ")
], -1)
const _hoisted_2 = ["disabled"]

import { useCheckout } from '../../useCheckout';
import { computed, withDefaults } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentOptions',
  props: {
    isClientValid: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isClientValid: boolean }



const labels = useBlockLabels();
const { basket, initiatePayment } = useCheckout();

const isValidForPayment = computed<boolean>(() => {
    const invalidDeliverable = basket.value?.deliverables.find(deliverable => !deliverable.isValid);
    const serverInvalid = !!invalidDeliverable;
    const clientInvalid = !props.isClientValid;
    return !serverInvalid && !clientInvalid;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'opacity-50': !_unref(isValidForPayment) })
  }, [
    _hoisted_1,
    _createElementVNode("button", {
      type: "button",
      class: "c-button c-button--primary mx-auto",
      disabled: !_unref(isValidForPayment),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(initiatePayment)()), ["prevent"]))
    }, _toDisplayString(_unref(labels).paymentSetPosTypeButton), 9, _hoisted_2)
  ], 2))
}
}

})